import { render } from "./CompliancesDetails.vue?vue&type=template&id=2ed7455c"
import script from "./CompliancesDetails.vue?vue&type=script&lang=js"
export * from "./CompliancesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__